<!-- ================= GRID SECTION ================= -->
<section>

  <div style="margin-bottom: 15px; text-align: left;">
    <button kendoButton class="btn btn-success" (click)="onAddFee()">Add Fee</button>
  </div>

  <kendo-grid [data]="gridView"
              [height]="650"
              [sortable]="true"
              [filterable]="true"
              [navigable]="true"
              [groupable]="false"
              [reorderable]="true"
              [sort]="gridState.sort"
              (sortChange)="onSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="gridState.take"
              [skip]="gridState.skip"
              (pageChange)="onPageChange($event)"
              (dataStateChange)="onDataStateChange($event)"
              [filter]="gridState.filter"
              [loading]="loading">

    <kendo-grid-column field="type" title="Type"></kendo-grid-column>
    <kendo-grid-column field="feeMode" title="Fixed/Variable"></kendo-grid-column>
    <kendo-grid-column field="minValue" title="Min value"></kendo-grid-column>
    <kendo-grid-column field="minQty" title="Min QTY"></kendo-grid-column>
    <kendo-grid-column field="fixedFee" title="Fixed Fee"></kendo-grid-column>
    <kendo-grid-column field="currency" title="Currency"></kendo-grid-column>


    <kendo-grid-column field="regionsText" title="Regions" [width]="220" filter="text">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.regionsText }}
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="startDate" title="Start Date"></kendo-grid-column>
    <kendo-grid-column field="message" title="Message" [width]="200"></kendo-grid-column>

    <kendo-grid-column field="active"
                       title="Active"
                       [width]="120"
                       [filterable]="true">

      <ng-template kendoGridFilterCellTemplate>
        <kendo-dropdownlist [data]="activeFilterDropdown"
                            textField="text"
                            valueField="value"
                            [valuePrimitive]="true"
                            [value]="activeHeaderValue"
                            (valueChange)="onActiveHeaderChange($event)"
                            style="width: 100%;">
        </kendo-dropdownlist>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [(ngModel)]="dataItem.active"
                      (click)="onToggleActive(dataItem)">
        </kendo-switch>
      </ng-template>

    </kendo-grid-column>

    <kendo-grid-command-column title="Action" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="k-button" (click)="onDelete(dataItem)">
          <span class="k-icon k-i-trash"></span>
        </button>
        <button class="k-button" (click)="onEdit(dataItem)">
          <span class="k-icon k-i-edit"></span>
        </button>
      </ng-template>
    </kendo-grid-command-column>

  </kendo-grid>
</section>

<!-- ================= ADD/EDIT FEE DIALOG ================= -->
<section class="dialogSection">
  <kendo-dialog [title]="isEdit ? 'Edit Fee' : 'Insert New Fee'"
                *ngIf="addFeeDialogOpened"
                (close)="closeAddFeeDialog()
                "
                cssClass="fee-dialog"
                [width]="900"
                [minWidth]="780">

    <form [formGroup]="addFeeForm" class="fee-form-grid">
      <div class="col">

        <div class="form-group">
          <label>Type <span class="required">*</span></label>
          <kendo-dropdownlist formControlName="type"
                              [data]="feeTypes"
                              textField="text"
                              valueField="value"
                              [valuePrimitive]="true"
                              class="kendoInput w-100">
          </kendo-dropdownlist>
        </div>

        <div class="form-group"
             [ngClass]="{ dimmed: addFeeForm.get('type')?.value === 'GLASSvent' }">
          <label>Fixed/Variable <span class="required">*</span></label>
          <kendo-dropdownlist formControlName="feeMode"
                              [data]="feeModes"
                              [valuePrimitive]="true"
                              class="kendoInput w-100"
                              [disabled]="addFeeForm.get('type')?.value === 'GLASSvent'">
          </kendo-dropdownlist>
        </div>

        <div class="form-group">
          <label>Currency <span class="required">*</span></label>
          <kendo-dropdownlist formControlName="currency"
                              [data]="currencies"
                              [valuePrimitive]="true"
                              class="kendoInput w-100">
          </kendo-dropdownlist>
        </div>

        <!-- Regions (multi-select) -->
        <div class="form-group">
          <label>Regions <span class="required">*</span></label>
          <kendo-multiselect formControlName="regions"
                             [data]="regionOptions"
                             textField="text"
                             valueField="value"
                             [valuePrimitive]="true"
                             class="kendoInput w-100"
                             [disabled]="!addFeeForm.get('currency') || !addFeeForm.get('currency').value"
                             [autoClose]="false">
          </kendo-multiselect>
        </div>

        <div class="form-group">
          <label>Start Date <span class="required">*</span></label>
          <kendo-datepicker formControlName="startDate"
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            [focusedDate]="today"
                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                            class="kendoInput w-100">
          </kendo-datepicker>
        </div>

        <div class="form-group switch-row">
          <label>Active <span class="required">*</span></label>
          <kendo-switch formControlName="active" [onLabel]="'Yes'" [offLabel]="'No'"></kendo-switch>
        </div>

      </div>

      <div class="col">

        <div class="form-group"
             [ngClass]="{ dimmed: addFeeForm.get('type')?.value === 'GLASSvent' }">
          <label>Min Value <span class="required">*</span></label>
          <kendo-numerictextbox formControlName="minValue"
                                [format]="'n2'"
                                [decimals]="2"
                                [min]="0"
                                class="kendoInput w-100"
                                [disabled]="addFeeForm.get('type')?.value === 'GLASSvent'">
          </kendo-numerictextbox>
        </div>

        <div class="form-group"
             [ngClass]="{
               dimmed:
                 addFeeForm.get('type')?.value === 'Extrusion' ||
                 addFeeForm.get('type')?.value === 'Order' ||
                 addFeeForm.get('type')?.value === 'Paint' ||
                 addFeeForm.get('feeMode')?.value === 'Variable'
             }">
          <label>Min QTY <span class="required">*</span></label>
          <kendo-numerictextbox formControlName="minQty"
                                [format]="'n0'"
                                [decimals]="0"
                                [min]="0"
                                class="kendoInput w-100"
                                [disabled]="
              addFeeForm.get('type')?.value === 'Extrusion' ||
              addFeeForm.get('type')?.value === 'Order' ||
              addFeeForm.get('type')?.value === 'Paint' ||
              addFeeForm.get('feeMode')?.value === 'Variable'
            ">
          </kendo-numerictextbox>
        </div>

        <div class="form-group"
             [ngClass]="{ dimmed: addFeeForm.get('feeMode')?.value === 'Variable' }">
          <label>Fixed Fee <span class="required">*</span></label>
          <kendo-numerictextbox formControlName="fixedFee"
                                [format]="'n2'"
                                [decimals]="2"
                                [min]="0"
                                class="kendoInput w-100"
                                [disabled]="addFeeForm.get('feeMode')?.value === 'Variable'">
          </kendo-numerictextbox>
        </div>

        <div class="form-group">
          <label>Message (ENG) <span class="required">*</span></label>

          <textarea kendoTextArea
                    formControlName="message"
                    class="kendoInput w-100 textarea-resizable"
                    rows="2"
                    maxlength="40"></textarea>

          <div class="char-counter">
            {{ (addFeeForm.get('message')?.value?.length || 0) }} / 40
          </div>

          <div class="validation-error"
               *ngIf="addFeeForm.get('message')?.touched &&
              addFeeForm.get('message')?.hasError('required')">
          </div>
        </div>
        
        <div class="form-group">
          <label>Message (FRE) <span class="required">*</span></label>

          <textarea kendoTextArea
                    formControlName="messageFr"
                    class="kendoInput w-100 textarea-resizable"
                    rows="2"
                    maxlength="40"></textarea>

          <div class="char-counter">
            {{ (addFeeForm.get('messageFr')?.value?.length || 0) }} / 40
          </div>

          <div class="validation-error"
               *ngIf="addFeeForm.get('messageFr')?.touched &&
              addFeeForm.get('messageFr')?.hasError('required')">
          </div>
        </div>
      </div>
    </form>

    <kendo-dialog-actions layout="end">
      <button kendoButton (click)="closeAddFeeDialog()">Cancel</button>
      <button kendoButton
              themeColor="primary"
              [disabled]="addFeeSaving || addFeeForm.invalid"
              (click)="saveAddFee()">
        {{ isEdit ? 'Update' : 'Add' }}
      </button>
    </kendo-dialog-actions>

  </kendo-dialog>
</section>

<!-- ================= DELETE CONFIRMATION ================= -->
<kendo-dialog *ngIf="deleteDialogOpened"
              (close)="cancelDelete()"
              title="Confirm Delete"
              [minWidth]="420">
  <p>Are you sure you want to delete this fee?</p>
  <p><strong>{{ deleteRow?.type }}</strong> - {{ (deleteRow?.regions || []).join(', ') }} ({{ deleteRow?.currency }})</p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="cancelDelete()">Cancel</button>
    <button kendoButton themeColor="primary" [disabled]="deleteBusy" (click)="confirmDelete()">Delete</button>
  </kendo-dialog-actions>
</kendo-dialog>
